import { useIntl } from 'react-intl';
import enUS from 'locales/en-US';
import frFR from 'locales/fr-FR';
import deDE from 'locales/de-DE';
import glbGlb from 'locales/glb-glb';
import { ddErrorLogwithContext } from 'utils/errorLoggerUtil.js';

const keyToIgnore = 'DEFAULT_TRANSLATION_KEY_FOR_OVERRIDE';

const localeMessagesMap = {
  'en-US': enUS,
  'fr-FR': frFR,
  'de-DE': deDE,
  'glb-glb': glbGlb,
};

const useTranslation = locale => {
  const intl = useIntl();

  const defaultInterpolationOptions = {
    p: chunks => <p>{chunks}</p>,
    strong: chunks => <strong>{chunks}</strong>,
  };

  // This is for a use-case where we need to force a translation to a locale that is different from the provider's current state
  const forceLocaleMessages = localeMessagesMap[locale] || enUS;

  const translateText = (translationKey, options = {}) => {
    const { defaultMessage, override, ...interpolations } = options;

    try {
      if (override) {
        const message = forceLocaleMessages[translationKey];
        return intl.formatMessage(
          {
            id: keyToIgnore,
            defaultMessage: defaultMessage || message || enUS[translationKey] || translationKey,
          },
          { ...interpolations, ...defaultInterpolationOptions },
        );
      }

      return intl.formatMessage(
        {
          id: translationKey,
          defaultMessage: defaultMessage || enUS[translationKey] || translationKey,
        },
        { ...interpolations, ...defaultInterpolationOptions },
      );
    } catch (error) {
      ddErrorLogwithContext(`[Translation Error] "${translationKey}" - ${error.message}`);
      return enUS[translationKey] || translationKey;
    }
  };

  return {
    translateText,
  };
};

export default useTranslation;
